export const MANDATORY_INVOICE_COUNTRIES = ['br', 'in'];

export const enum BeneficiaryType {
  SAME_COMPANY = 'same_company',
  EXTERNAL_PROVIDER = 'external_provider',
}
export type PaymentMethod = 0 | 2 | 3 | 7 | 8 | 18 | 19 | 1001;

export const PAYMENT_METHOD = {
  BANK_TRANSFER: 0,
  VISA_CREDIT: 2,
  MASTERCARD_CREDIT: 3,
  VISA_DEBIT: 7,
  MASTERCARD_DEBIT: 8,
  CREDIT_DEBIT_CARD: 18,
  PSE_TRANSFER: 19,
  PIX_TRANSFER: 1001,
} as const;

export const BANK_TRANSFER_METHODS: number[] = [
  PAYMENT_METHOD.BANK_TRANSFER,
  PAYMENT_METHOD.PSE_TRANSFER,
  PAYMENT_METHOD.PIX_TRANSFER,
];

export const CARD_PAYMENT_METHODS: number[] = [
  PAYMENT_METHOD.VISA_CREDIT,
  PAYMENT_METHOD.VISA_DEBIT,
  PAYMENT_METHOD.MASTERCARD_CREDIT,
  PAYMENT_METHOD.MASTERCARD_DEBIT,
  PAYMENT_METHOD.CREDIT_DEBIT_CARD,
];
